import { render, staticRenderFns } from "./AdminTotalsByYears.vue?vue&type=template&id=6c09bb43&scoped=true"
import script from "./AdminTotalsByYears.vue?vue&type=script&lang=js"
export * from "./AdminTotalsByYears.vue?vue&type=script&lang=js"
import style0 from "./AdminTotalsByYears.vue?vue&type=style&index=0&id=6c09bb43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c09bb43",
  null
  
)

export default component.exports